const searchTabs = [document.getElementById('sbr'), document.getElementById('sbv'), document.getElementById('sbt'), document.getElementById('sbw')];
const filterCategories = [document.getElementById('rego-filters'), document.getElementById('vehicle-filters'), document.getElementById('tyre-search'), document.getElementById('wheel-search')];

if (window.innerWidth < 750) {

    for (i = 0; i < searchTabs.length; i++) {
        if (searchTabs[i]) {
            searchTabs[i].classList.remove('switchActive');
            searchTabs[i].classList.remove('mobNull');
            searchTabs[i].classList.add('switchOff');
            filterCategories[i].style.display = 'none';
            filterCategories[i].style.opacity = '0';
            filterCategories[i].classList.remove('mobActive');

            searchTabs[i].addEventListener('click', function () {
                /*if (this.classList.contains('switchActive')) {
                    let instance = searchTabs.indexOf(this);
                    setTimeout(() => {
                        filterCategories[instance].style.opacity = 0;
                    }, this.animationDelay + 20);
                    filterCategories[instance].style.display = 'none';
                    this.classList.remove('switchActive');
                    this.classList.add('switchOff');
                    this.classList.remove('headerSwitch-reverse');
                    this.classList.add('headerSwitch');
                } else {*/
                    for (j = 0; j < filterCategories.length; j++) {
                        let instance = j;
                        if (filterCategories[j]) {
                            if (searchTabs[j] == this) {
                                filterCategories[j].style.display = 'block';
                                setTimeout(() => {
                                    filterCategories[instance].style.opacity = 1;
                                }, this.animationDelay + 20);
                                searchTabs[j].classList.add('switchActive');
                                searchTabs[j].classList.remove('switchOff');
                                searchTabs[j].classList.add('headerSwitch-reverse');
                                searchTabs[j].classList.remove('headerSwitch');
                            } else {
                                setTimeout(() => {
                                    filterCategories[instance].style.opacity = 0;
                                }, this.animationDelay + 20);
                                filterCategories[j].style.display = 'none';
                                searchTabs[j].classList.remove('switchActive');
                                searchTabs[j].classList.add('switchOff');
                                searchTabs[j].classList.remove('headerSwitch-reverse');
                                searchTabs[j].classList.add('headerSwitch');
                            }
                        }
                    }
                //}
            })
        }
    }
}